import type { GroupResponsibleTabName } from '@/scopes/account/group-responsible/domain/types'
import { BookingTags } from '@/scopes/account/common/components'
import { Hero as CommonHero, type Tabs } from '@/scopes/account/common/components/Hero'
import { useAccountBookingQueryParam } from '@/scopes/account/common/hooks'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { getPublicationCodeByCatalogueAndSiteName } from '@/scopes/common/domain/functions/publicationCodes'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useCollection } from '../../domain/hooks'
import { getBookingPageUrl } from '../../domain/policies/bookingPageUrl'
import { useGroupResponsibleUseCases } from '../dependencies'
import { getDaysUntilDeparture, isGroupBookingOnHolidays } from '../selectors/commonSelectors'

export function Hero() {
  const siteName = useConfiguration('siteName')
  const publicationCode = getPublicationCodeByCatalogueAndSiteName('summer', siteName)
  const bookingPageUrl = getBookingPageUrl(publicationCode)
  const bookingNumber = useAccountBookingQueryParam('bookingNumber')
  const collection = useCollection()
  const useCases = useGroupResponsibleUseCases()
  const groupName = useGroupResponsibleStore((state) => {
    return state.bookingData.group.name
  })

  const groupLocation = useGroupResponsibleStore((state) => {
    return state.bookingData.group.location
  })

  const groupPeriod = useGroupResponsibleStore((state) => {
    return state.bookingData.group.period
  })

  const isOnHolidays = useGroupResponsibleStore(isGroupBookingOnHolidays)
  const daysUntilDeparture = useGroupResponsibleStore(getDaysUntilDeparture)

  const activeTab = useGroupResponsibleStore((state) => {
    return state.activeTab
  })

  const imageSrc = useGroupResponsibleStore((state) => {
    return state.bookingData.group.imgSrc
  })

  const handleTabChange = (value: Tabs) => {
    if (value === 'booking' && bookingNumber) {
      const queryParams = new URLSearchParams({ bookingNumber })
      window.location.href = `${bookingPageUrl}?${queryParams.toString()}`
      return
    }

    useCases.tabSelected(value as GroupResponsibleTabName)
  }

  const tags = (
    <BookingTags
      isTotallySnow={collection === 'totally_snow'}
      isPrimavera={collection === 'primavera'}
      isGroupBooking
      isOnHolidays={isOnHolidays}
      daysUntilDeparture={daysUntilDeparture}
    />
  )

  return (
    <CommonHero
      title={groupName}
      bookingNumber={bookingNumber}
      location={groupLocation}
      period={groupPeriod}
      activeTab={activeTab}
      tags={tags}
      backgroundImageSrc={imageSrc}
      onTabChange={handleTabChange}
    />
  )
}
